<template>

    <div>

        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <div class="col-md-9">
                    <input class="form-control filterInput" type="search" placeholder="Masukkan Nomor TO/NOPOL"
                        aria-label="Search" style="font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search">
                </div>
                <div class="col-md-3 text-right">
                    <button class="btn" type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold; font: normal normal 600 14px/21px Poppins;"
                        @click="fetchData">CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Title & Option Buttons Start -->
        <div class="row">
            <div class="col-md-3">
                <button class="btn btn--mpm--transporter" @click="requestFullScreen"
                    style="font: normal normal normal 12px/18px Poppins;">Full Screen</button>
            </div>
            <div class="col-md-4 text-center" style="display: flex; flex-direction: column-reverse;">
                <h3 style="font: normal normal normal 16px/25px Poppins;">Dashboard Tracking</h3>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-4">
                <div class="d-flex">
                    <div class="col-4"
                        style="display: flex; align-items: center; font: normal normal normal 12px/18px Poppins;">
                        <span style="font: normal normal normal 12px/18px Poppins;">Filter Tanggal</span>
                    </div>
                    <div class="col-8">
                        <flat-pickr :config="datePickr" placeholder="Select Date" v-model="filter.date"
                            style="font: normal normal normal 12px/18px Poppins;"></flat-pickr>
                    </div>
                </div>
            </div>
        </div>
        <!-- Title & Option Buttons End -->

        <!-- Stats Start -->
        <hr style="background: #EFEFEF;">
        <div class="row mb-4">
            <div class="col-lg-3 col-md-6">
                <div class="innerBox">
                    <truck-tracking-stats title="Validasi Truck"
                        :value="data.stats ? data.stats.validasi != null ? numberWithCommas(data.stats.validasi) : 'N/A' : 'Loading...'"
                        icon="truckCheck" style="font: normal normal normal 20px/30px Poppins;"></truck-tracking-stats>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="innerBox">
                    <truck-tracking-stats title="Pengecekan"
                        :value="data.stats ? data.stats.pengecekan != null ? numberWithCommas(data.stats.pengecekan) : 'N/A' : 'Loading...'"
                        icon="clipboardCheck"
                        style="font: normal normal normal 20px/30px Poppins;"></truck-tracking-stats>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="innerBox">
                    <truck-tracking-stats title="Pengiriman"
                        :value="data.stats ? data.stats.pengiriman != null ? numberWithCommas(data.stats.pengiriman) : 'N/A' : 'Loading...'"
                        icon="truck" style="font: normal normal normal 20px/30px Poppins;"></truck-tracking-stats>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="innerBox">
                    <truck-tracking-stats title="Idle"
                        :value="data.stats ? data.stats.idle != null ? numberWithCommas(data.stats.idle) : 'N/A' : 'Loading...'"
                        style="font: normal normal normal 20px/30px Poppins;"></truck-tracking-stats>
                </div>
            </div>
        </div>
        <hr style="background: #EFEFEF;">
        <!-- Stats End -->

        <!-- Daftar pengiriman new table  -->

        <div class="innerBox">
            <div class="mb-4 row">
                <!-- Title Section -->
                <div class="col-md-5 text-left d-flex flex-column-reverse">
                    <h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins">
                        Daftar Pengiriman
                    </h3>
                </div>

                <div class="col-md-4"></div> <!-- Spacer -->

                <!-- Filter Section -->
                <div class="col-md-3">


                    <div class="d-flex justify-content-end">
                        <div class="d-flex align-items-center" style="font: normal normal normal 12px/18px Poppins;">
                            <div class="mr-4">
                                <span>GPS Activation</span>
                                <label class="switch" style="margin: 0 12px;">
                                    <input type="checkbox" v-model="gpsActivation" @change="updateGpsStatus">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                            <img :src="isDisabled ? require('@/assets/img/gear-disabled.svg') : require('@/assets/img/gear.svg')" class="icon-img mr-3" :style="{ width: '24px', height: '24px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }" :disabled="isDisabled" @click="!isDisabled && (modal = true)" />
                        </div>
                    </div>


                </div>
            </div>

            <vue-universal-table api_url="/api/monitoring/new-daftar-pengiriman" :filter="filter"
                :update="vue_universal_table.update" :fields="vue_universal_table.fields" :infinite_scroll="true"
                :data="data.newDaftarPengiriman" :buttons="vue_universal_table.buttons"
                sort_order="DESC" sort_by="total_sl"
                :buttons_disabled="isDisabled"
                @onDetailMaps="handleDetailMaps"></vue-universal-table>


        </div>

        <EditRadius 
            v-if="modal"
            @closeModal = "modal = false"
            :data="radius"
        />






        <!-- Daftar pengiriman new table end   -->

        <!-- Daftar Pengiriman Start -->
        <!-- <div class="row">
            <h4 class="col-md-2" style="font: normal normal normal 20px/30px Poppins;">Daftar Pengiriman</h4>
            <div class="row mt-2 ml-2">
                <h2 class="row-md-2 mr-2" style="font: normal normal normal 14px/21px Poppins;"><span class="dot--cancel mr-1"></span>Dibatalkan</h2>
                <h2 class="row-md-2 ml-2" style="font: normal normal normal 14px/21px Poppins;"><span class="dot--terkirim mr-1"></span>Terkirim</h2>
            </div>
        </div>
        <div class="daftar--pengiriman" v-if="data.daftarPengiriman">
            <template v-if="data.daftarPengiriman.length > 0">
                <div v-for="dat in data.daftarPengiriman">
                    <tracking-row-status
                        :data="dat"
                    ></tracking-row-status>
                </div>
            </template>
<div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
    <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">No Data</p>
</div>
</div>
<div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
    <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
</div> -->
        <!-- Daftar Pengiriman End -->

    </div>
</template>

<script>
import qs from 'qs'
import moment from 'moment'

import TruckTrackingStats from './children/TruckTrackingStats'
import trackingRowStatus from './children/trackingRowStatus'
import EditRadius from './children/EditRadius'


export default {
    metaInfo: {
        title: 'Truck Tracking'
    },
    data() {
        return {
            data: {
                stats: null,
                daftarPengiriman: null,
                newDaftarPengiriman: null
            },
            isDisabled: false,
            radius: 0,
            datePickr: {
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d/m/Y",
                altInputClass: 'form-control input mpm--transporter--flatpickr'
            },
            filter: {
                search: null,
                date: moment().format("YYYY-MM-DD")
            },
            gpsActivation: true,
            modal: false,

            vue_universal_table: {
                fields: [
                    { title: "NOPOL", variable: "nopol", disable_sort: true },
                    { title: "No TO", variable: "no_referensi", disable_sort: true },
                    { title: "Rute", variable: "kode_rute", disable_sort: true },
                    { title: "Last Location", variable: "location_name", disable_sort: true },
                    { title: "Total", variable: "total_sl" },
                    { title: "Terkirim", variable: "jumlah_terkirim", disable_sort: true },
                    { title: "Dibatalkan", variable: "jumlah_cancel", disable_sort: true },
                    { title: "Sisa Pengiriman", variable: "sisa_pengiriman", disable_sort: true },
                ],

                buttons: [
                    {
                        title: 'detailMaps',
                        class: "fas fa-map-marker-alt btn-outline-warning"
                    }
                ],
                update: 0,
            },
        }
    },
    components: {
        TruckTrackingStats,
        trackingRowStatus,
        EditRadius
    },
    mounted() {
        // this.generateDummyData();
        this.fetchData();

        this.getStatus();
    },
    watch: {
        'filter.date': {
            deep: true,
            handler: 'fetchData',
        },


    },
    methods: {
        getStatus() {

            this.$http.get(`/api/monitoring/list-status-track-location`)
                .then((resp) => {
                    const status = resp.data.data;

                    this.radius = Number(status.radius);

                    if (status.status == 0) {
                        this.gpsActivation = false;
                        this.isDisabled = true;
                    }

                })
                .catch((err) => { console.log(err) });

        },

        updateGpsStatus() {
            const status = this.gpsActivation ? 1 : 0;

            this.isDisabled = !this.gpsActivation;

            this.$http.patch('/api/monitoring/status-track-location', { status: status })
                .then(response => {
                    console.log('Berhasil update status GPS:');
                    // console.log('Berhasil update status GPS:', response.data);
                })
                .catch(error => {
                    console.error('Gagal update status GPS:', error);
                    this.gpsActivation = !this.gpsActivation;
                });

        },

        handleDetailMaps(data) {
            this.$store.dispatch('setTruckTrackingData', data.replace(/\n/g, '\\n'));
            this.$router.push({ path: "/dashboard/truck-tracking/detail" });
        },
        requestFullScreen() {
            var element = document.body; // Make the body go full screen.

            // Supports most browsers and their versions.
            var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

            if (requestMethod) { // Native full screen.
                requestMethod.call(element);
            } else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
                var wscript = new ActiveXObject("WScript.Shell");
                if (wscript !== null) {
                    wscript.SendKeys("{F11}");
                }
            }
        },
        generateDummyData() {
            let dummyData = []

            for (var i = 0; i < 20; i++) {
                let progress = this.randomInt(1, 20)
                dummyData.push({
                    "current_route": `W ${this.randomInt(1000, 9999)} P`,
                    "rute": `Batu ${i + this.randomInt(0, 1000)}`,
                    "jumlah_dealer_terkirim": progress,
                    "jumlah_dealer": progress + this.randomInt(0, 20)
                })
            }

            this.dummyData = dummyData;
        },
        fetchData() {

            this.vue_universal_table.update++;

            //Reset Data
            for (var i in this.data) this.data[i] = null;

            //Reset Search To null if empty string
            if (this.filter.search == "") this.filter.search = null;

            //Get Stats
            this.$http.get(`/api/monitoring/stats?${qs.stringify(this.filter, { skipNulls: true, arrayFormat: 'comma' })}`)
                .then((resp) => {
                    this.data.stats = resp.data.data;
                })
                .catch((err) => { console.log(err) });

            //Get Daftar Pengiriman
            this.$http.get(`/api/monitoring/daftar-pengiriman?${qs.stringify(this.filter, { skipNulls: true, arrayFormat: 'comma' })}`)
                .then((resp) => {
                    this.data.daftarPengiriman = resp.data.data;
                })
                .catch((err) => { console.log(err) });

            // new 


            // this.$http.get(`/api/monitoring/new-daftar-pengiriman?${qs.stringify({...this.filter, date: dateParam}, {skipNulls:true, arrayFormat: 'comma'})}`)
            // .then((resp)=>{
            //     this.data.newDaftarPengiriman = resp.data.data;
            // })
            // .catch((err)=>{console.log(err)});
        },

    },


}
</script>

<style scoped>
.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000F;
    padding: 20px;
}

.filterInput::placeholder {
    color: #BBBBBB;
    font: normal normal normal 16px/25px;
}

.daftar--pengiriman {
    padding-right: 20px;
    max-height: 40vh;
    overflow-x: hidden;
}

.daftar--pengiriman::-webkit-scrollbar {
    width: 1em;
}

.daftar--pengiriman::-webkit-scrollbar-track {
    background-color: #F9F9F9;
    border-radius: 20px;
}

.daftar--pengiriman::-webkit-scrollbar-thumb {
    background-color: #A2A2A2;
    border: 2px solid #707070;
    border-radius: 20px;
}

.dot--terkirim {
    height: 14px;
    width: 14px;
    background-color: #61FB50;
    border-radius: 10%;
    display: inline-block;
}

.dot--cancel {
    height: 14px;
    width: 14px;
    background-color: #FF919E;
    border-radius: 20%;
    display: inline-block;
}


.switch {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 18px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
}

input:checked+.slider {
    background-color: #2196F3;
}

input:checked+.slider:before {
    transform: translateX(16px);
}

/* Disabled button styles */
::v-deep .btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    border-color: #dee2e6 !important;
    background-color: #f8f9fa !important;
}

::v-deep .btn:disabled .fas {
    opacity: 0.4;
    color: #6c757d !important;
}
</style>